import * as React from 'react';
function useClickOutside(ref, handler, deps) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const callback = React.useCallback((event) => handler(event), deps !== null && deps !== void 0 ? deps : []);
    React.useEffect(() => {
        var _a;
        const el = (_a = ref === null || ref === void 0 ? void 0 : ref.current) !== null && _a !== void 0 ? _a : ref;
        if (!el)
            return undefined;
        let throttle = false;
        const setThrottle = () => {
            throttle = true;
            setTimeout(() => (throttle = false), 500);
        };
        const listener = (event) => {
            if (!el || !el.contains || el.contains(event.target) || throttle) {
                setThrottle();
                return;
            }
            setThrottle();
            callback(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        document.addEventListener('click', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
            document.removeEventListener('click', listener);
        };
    }, [ref, callback]);
}
export default useClickOutside;
